export const graphImage = (src) => (
    require('../assets' + src).default
)